import { ElMessage } from 'element-plus'

/**
 * 统一处理 POST /inventory-transactions 响应（含 202 审批待办）。
 * @returns {{ success: boolean, pendingApproval?: boolean, requestId?: number, data?: object, message?: string }}
 */
export function interpretInventoryTransactionResponse(response, defaultSuccessMsg = '操作成功') {
  if (!response) {
    return { success: false, message: '无响应' }
  }
  if (response.pending_approval) {
    const msg = response.message || '已提交管理员审批，通过后方可入账'
    return {
      success: true,
      pendingApproval: true,
      requestId: response.request_id,
      message: msg
    }
  }
  if (response.success) {
    return {
      success: true,
      data: response.data,
      message: response.message || defaultSuccessMsg
    }
  }
  return {
    success: false,
    message: response.message || '操作失败'
  }
}

export function notifyInventoryTransactionResult(result, { successType = 'success' } = {}) {
  if (!result?.success) {
    ElMessage.error(result?.message || '操作失败')
    return false
  }
  if (result.pendingApproval) {
    ElMessage.success(result.message)
    return true
  }
  ElMessage[successType](result.message || '操作成功')
  return true
}
